module.exports = __webpack_public_path__ + "img/moto-ride--icon--gray.5c9758bb.svg";